module.exports = __webpack_public_path__ + "img/throwingeggs.38d3e65d.jpg";